<template>
  <div class="tugas">
    <div class="header">
      <h3>Notulen</h3>
      <div @click="openSearch()">
        <search v-show="!searchOpen" />
        <close v-show="searchOpen" />
      </div>

      <div class="search" :class="{ active: searchOpen }">
        <input
          type="text"
          ref="input_search"
          placeholder="Cari judul pekerjaan"
          v-model="keyword"
          @input="handleInput"
        />
      </div>
    </div>

    <div class="body">
      <div class="task">
        <div class="skeleton-wrapper" v-show="loading">
          <div
            class="skeleton"
            v-for="(item, index) in [1, 1, 1, 1, 1]"
            :key="index"
          ></div>
        </div>
        <ul v-show="!loading">
          <li
            v-for="(item, index) in data"
            :key="index"
            @click="to('/notulen/' + item.id)"
            :class="item.status == 'DONE' ? 'done' : ''"
          >
            <div>
              <b
                v-show="$user.access == 'ADMIN' || $user.access == 'NOTULEN'"
                >{{ item.user }}</b
              >
              <p>{{ item.catatan }}</p>
              <small>{{ moment(item.tgl_notulen).format("DD/MM/YYYY") }}</small>
            </div>
            <div
              style="width: 40px; display: flex; justify-content: flex-end"
              @click.stop="check(item)"
              v-if="$user.access == 'ADMIN'"
            >
              <span class="circle" v-show="item.status == null"></span>
              <check-circle v-show="item.status == 'DONE'"></check-circle>
            </div>
          </li>
        </ul>

        <div
          style="text-align: center; padding: 60px 0"
          v-show="!loading && data.length <= 0"
        >
          <p>Tidak ada catatan</p>
        </div>
      </div>

      <div
        class="fab"
        v-show="$user.access == 'NOTULEN' || $user.access == 'ADMIN'"
      >
        <router-link to="/notulen/-1">
          <span>+</span> Notulen Baru
        </router-link>
      </div>
    </div>

    <div
      class="overlay"
      :class="{ show: searchOpen }"
      @click="closeSearch()"
    ></div>
  </div>
</template>

<script>
import moment from "moment";
import { debounce } from "lodash";

import * as api from "./../api/Api";

import Loading from "./icons/Loading";
import Search from "./icons/Search";
import CheckCircle from "./icons/CheckCircle";
import Close from "./icons/CloseOutline";

export default {
  name: "Task",
  components: {
    Search,
    CheckCircle,
    Close,
    Loading,
  },
  data() {
    return {
      loading: false,
      searchOpen: false,
      data: [],
      user: [],
      keyword: "",

      filter: {
        user: "",
      },
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;

      let param = "";
      if (this.$user.access != "ADMIN" && this.$user.access != "NOTULEN") {
        param += "id_user=" + this.$user.id;
      }

      api.get("/v1/kendali_kerja/notulenController/get?" + param).then((r) => {
        this.data = r.data;
        this.loading = false;
      });
    },
    check(item) {
      setTimeout(() => {
        if (item.status == "DONE") {
          item.status = null;
        } else {
          item.status = "DONE";
        }

        api
          .post("/v1/kendali_kerja/NotulenController/update", item)
          .then((r) => {
            this.loadData();
          });
      }, 150);
    },
    to(to) {
      setTimeout(() => {
        this.$router.push(to);
      }, 150);
    },
    openSearch() {
      this.searchOpen = !this.searchOpen;

      if (this.searchOpen !== false) {
        setTimeout(() => {
          this.$refs["input_search"].focus();
        }, 150);
      } else {
      }
    },
    closeSearch() {
      this.searchOpen = false;
    },
    handleInput() {
      // Membatalkan timeout sebelumnya (jika ada)
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      // Menjalankan logika dengan waktu jeda 300 milidetik
      this.timeout = setTimeout(() => {
        // Logika yang akan dijalankan setelah waktu jeda

        if (this.keyword) {
          let param = "id_user=" + this.$user.id + "&keyword=" + this.keyword;

          if (this.$user.access == "ADMIN") {
            param = "id_user=" + this.filter.user + "&keyword=" + this.keyword;
          }

          this.loading = true;
          this.searchOpen = false;

          api
            .get("/v1/kendali_kerja/pekerjaanController/filter?" + param)
            .then((r) => {
              this.data = r.data;
              this.loading = false;
            });
        } else {
          this.loadData("TODO");
        }

        this.timeout = null; // Mengatur timeout kembali menjadi null setelah selesai
      }, 500);
    },
  },
  mounted() {
    if (this.$user.access == "ADMIN") {
      this.user = this.$store.state.user.data;

      if (this.$route.query.id_user) {
        this.filter.user = this.$route.query.id_user;
      } else {
        this.filter.user = this.$user.id;
      }

      if (this.$route.query.status) {
        this.status = this.$route.query.status;
      }
    }

    this.loadData(this.status);
  },
};
</script>

<style scoped lang="scss">
.tugas {
  padding: 20px;

  .header {
    position: fixed;
    z-index: 2;
    top: 0;
    left: calc(50% - 240px);
    width: 440px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    padding: 15px 20px;
    background: #fff;

    @media screen and (max-width: 768px) {
      left: 0;
      width: 100%;
    }

    h3 {
      margin: 0;
    }
    .search {
      flex: 100%;
      height: 0;
      opacity: 0;
      transition: all 0.3s ease;

      input {
        margin-top: 10px;
      }

      &.active {
        height: 50px;
        opacity: 1;
      }
    }
  }

  .body {
    padding-top: 50px;
    padding-bottom: 100px;
    .task {
      padding: 0;

      .loading {
        display: flex;
        justify-content: center;
        padding: 50px 0;
      }

      .icon {
        width: 30px;
        height: 30px;
        color: #666;
        margin-right: -3px;
        transform: scale(1);
        &:active {
          transition: all 0.3s ease;
          transform: scale(1.3);
        }
      }

      small {
        margin-top: 6px;
        font-size: 12px;
        display: block;
      }

      b {
        font-size: 12px;
        display: block;
        margin-bottom: 5px;
        font-weight: normal;
        color: #666;
      }

      span.circle {
        width: 20px;
        height: 20px;
        border: 2px solid #999;
        border-radius: 60px;
        transform: scale(1);
        &:active {
          transition: all 0.3s ease;
          transform: scale(1.3);
        }
      }

      ul {
        li {
          p {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        li.done {
          div {
            p {
              text-decoration: line-through;
            }
          }
        }
      }
    }

    .fab {
      position: fixed;
      bottom: 80px;
      right: calc(50% - 220px);

      @media screen and (max-width: 768px) {
        right: 20px;
      }

      a {
        background-color: #0588ff;
        color: #fff;
        padding: 5px 26px 5px 20px;
        border-radius: 60px;
        text-decoration: none;
        box-shadow: 0px 3px 3px #ccc;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 15px;

        span {
          font-size: 28px;
        }
      }
    }
  }

  .tab {
    margin-bottom: 20px;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      gap: 6px;

      li {
        padding: 10px 12px;
        border-bottom: 2px solid #fff;
        text-align: center;
        font-size: 14px;
        transition: all 0.3s ease;
        &.active {
          background: #0588ff;
          color: #fff;
          border-radius: 50px;
        }
        &:active {
          background-color: #eee;
        }
      }
    }
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.3);
    visibility: hidden;
    opacity: 0;
    transition: all 0.6s ease;
    &.show {
      opacity: 1;
      visibility: visible;
    }
  }
}

.skeleton-wrapper {
  .skeleton {
    min-height: 65px;
    border-radius: 4px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Notulen.vue